import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import SpaceBase from '../../SpaceBase/index.js';
import { LazySpaceBlogRedirect } from '../lazyComponents.js';
export const BlogHomeRoute = () => (
	<SpaceBase>
		<LazySpaceBlogRedirect />
	</SpaceBase>
);
BlogHomeRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		screenEvent: { name: 'blogHomeScreen' },
		pageState: { spaceKey, contentId },
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
	},
});
